import { RoutedModal } from "../../../../components/common";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { ArrowRight, SaveIcon } from "../../../../assets/svgIcons";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useReconcileStocks from "../../../appPages/Inventory/Reconciliation/ReconcileStocks/useReconcileStocks";

export const SMReconcileStock = () => {
  const {
    storeName,
    isSubmitting,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    products,
    reconciliedData,
    isSaving,
    isLoadingDiscrepancy,
    discrepancyReasons,
    isReconciliationPrompt,
    categoryList,
    filters,
    storeDetails,
    stockStatusList,
    setFilters,
    submitReconciliation,
    saveDraft,
    setReconciliedData,
    setIsReconciliationPrompt,
  } = useReconcileStocks();

  return (
    <RoutedModal
      isActive={true}
      hasPrevNavigation={true}
      headerTitle={`Stock Reconciliation - ${storeName}`}
      headerDescription="Please note that this page autosave every 5 mins"
      rightHeaderSide={
        <div className="d-flex ml-auto">
          <primaryComponents.Button
            classNames="btn btn--primary mr-2"
            onClick={() => setIsReconciliationPrompt(true)}
            isDisabled={isSubmitting}
            isLoading={isSubmitting}
            loadingText="Submitting..."
          >
            <ArrowRight style={{ fontSize: "20px" }} className="mr-1" />
            Submit
          </primaryComponents.Button>
          <primaryComponents.Button
            classNames="btn btn--outline"
            onClick={() => saveDraft(false)}
            isDisabled={isSaving}
          >
            <SaveIcon
              style={{ fontSize: "20px" }}
              className="dark--text mr-1"
            />
            Save
          </primaryComponents.Button>
        </div>
      }
    >
      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder="Search by product name"
            value={filters?.searchQuery}
            trigger={(value) =>
              setFilters((prev) => ({ ...prev, searchQuery: value }))
            }
            triggerOnInput={true}
            showsearchBtn
          />

          <div
            className="ml-auto d-flex"
            style={{ maxWidth: "400px", width: "100%", gap: "10px" }}
          >
            <div style={{ width: "50%" }}>
              <primaryComponents.SelectField
                name="stock_status"
                options={stockStatusList}
                idKey="value"
                nameKey="name"
                value={filters?.stock_status || "Filter Stock Status"}
                placeholder="Filter by stock status"
                onChange={(value) => {
                  setFilters((prev) => ({ ...prev, stock_status: value }));
                }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <primaryComponents.MultipleSelectField
                name="categories"
                options={categoryList}
                idKey="id"
                nameKey="name"
                placeholder="Select Categories"
                onChange={(values) => {
                  let newValues = [];
                  values?.forEach((item) => {
                    newValues.push(item.value);
                  });
                  setFilters((prev) => ({ ...prev, categories: newValues }));
                }}
                floatError={false}
              />
            </div>
          </div>
        </div>

        <div>
          <secondaryComponents.LoaderHelper
            classNames="my-5"
            isLoading={isLoading || isLoadingDiscrepancy}
          >
            <secondaryComponents.ReconcileStockEditView
              store_currency={storeDetails?.currency_code}
              products={products}
              setReconciliedData={setReconciliedData}
              reconciliedData={reconciliedData}
              discrepancyReasons={discrepancyReasons}
              hasNextPage={hasNextPage}
              isFetchingNextPage={isFetchingNextPage}
              fetchNextPage={fetchNextPage}
              action={() => setIsReconciliationPrompt(true)}
              isLoading={isSubmitting}
              loadingText={"Applying..."}
            />
          </secondaryComponents.LoaderHelper>

          <secondaryComponents.LoaderHelper
            classNames="mt-4"
            isLoading={isFetchingNextPage && !isLoading}
          ></secondaryComponents.LoaderHelper>
        </div>
      </section>

      <secondaryComponents.Modal
        isActive={isReconciliationPrompt}
        closeModal={() => setIsReconciliationPrompt(false)}
        width="500px"
      >
        <secondaryComponents.ReconciliationReviewPrompt
          closeModal={() => setIsReconciliationPrompt(false)}
          reconciliationType="firstSubmission"
          proceed={() => {
            submitReconciliation();
            setIsReconciliationPrompt(false);
          }}
        />
      </secondaryComponents.Modal>
    </RoutedModal>
  );
};
